import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png';

const Footer = () => (
  <footer className="bg-gray-900/80 backdrop-blur-xl border-t border-gray-800/80 py-16">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid md:grid-cols-4 gap-12 mb-12">
        <div className="md:col-span-2">
          <Link to="/" className="flex items-center space-x-3 mb-6">
            <div className="w-10 h-10 rounded-xl overflow-hidden">
              <img src={logo} alt="Logo" className="w-full h-full object-cover" />
            </div>
            <span className="text-2xl font-bold bg-gradient-to-r from-primary-400 to-accent-400 bg-clip-text text-transparent">Advance Advert Tv Digital</span>
          </Link>
          <p className="text-gray-400 max-w-sm leading-relaxed">Your trusted partner for foreign TikTok accounts. Unlock global reach and maximize your content potential.</p>
        </div>
        <div>
          <h4 className="text-white font-bold mb-5 text-lg">Quick Links</h4>
          <ul className="space-y-3">
            <li><Link to="/" className="text-gray-400 hover:text-white transition-colors text-sm">Home</Link></li>
            <li><Link to="/pricing" className="text-gray-400 hover:text-white transition-colors text-sm">Pricing</Link></li>
            <li><Link to="/faq" className="text-gray-400 hover:text-white transition-colors text-sm">FAQ</Link></li>
            <li><Link to="/support" className="text-gray-400 hover:text-white transition-colors text-sm">Support</Link></li>
            <li><Link to="/track" className="text-gray-400 hover:text-white transition-colors text-sm">Track Order</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-bold mb-5 text-lg">Legal</h4>
          <ul className="space-y-3">
            <li><Link to="/privacy-policy" className="text-gray-400 hover:text-white transition-colors text-sm">Privacy Policy</Link></li>
            <li><Link to="/terms-of-service" className="text-gray-400 hover:text-white transition-colors text-sm">Terms of Service</Link></li>
            <li><Link to="/refund-policy" className="text-gray-400 hover:text-white transition-colors text-sm">Refund Policy</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-gray-800/80 pt-8 flex flex-col md:flex-row items-center justify-between gap-6">
        <p className="text-gray-500 text-sm">&copy; {new Date().getFullYear()} Advance Advert Tv Digital. All rights reserved.</p>
      </div>
    </div>
  </footer>
);

export default Footer;
